module.exports = __webpack_public_path__ + "img/banner_1.a3ce2672.jpg";